import * as accountsApi from '@/network/api/accounts.api.js'
import * as signedApi from '@/network/api/operations/signed.api.js'
import * as operationsApi from '@/network/api/operations/operations.api.js'
import * as operatorsApi from '@/network/api/operators.api.js'

/** requests accounts balances
@return { promise } - Accounts balances request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountsApi.requestAccountsBalances()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCE', data)
    }
    return res
}

/** requests accounts with operations pending signature
@return { promise } - Accounts request
*/
export const requestAccountsWithOperationsPendingSignature = async (context, payload) => {
    const res = await signedApi.getAccountsWithOperationsPendingSignature()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_WITH_OPERATIONS_PENDING_SIGNATURE', data)
    }
    return res
}

/** Clear accounts accounts with operations pending signature */
export const clearAccountsWithOperationsPendingSignature = (context, payload) => {
    context.commit('SAVE_ACCOUNTS_WITH_OPERATIONS_PENDING_SIGNATURE', [])
}

/** requests operation details
@return { promise } - Operation details request
*/
export const requestOperationDetails = async (context, payload) => {
    const res = await operationsApi.getOperationGenericDetail(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_OPERATION_DETAILS', data)
    }
    return res
}

/** requests accounts list
@return { promise } - Accounts request
*/
export const requestAccountsList = async (context, payload) => {
    const res = await accountsApi.accounts()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_LIST', data)
    }
    return res
}

/** requests profiles list
@return { promise } - Profiles list request
*/
export const requestProfilesList = async (context, payload) => {
    const res = await operatorsApi.getOperatorsProfilesList()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PROFILES_LIST', data)
    }
    return res
}

/** request Operator Detail
@return { promise } - Operator detail request
*/
export const requestOperatorDetail = async (context, payload) => {
    const res = await operatorsApi.getOperatorDetail(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_OPERATOR_DETAILS', data)
    }
    return res
}

/** request operations types
@return { promise } - operations types request
*/
export const requestOperationsTypes = async context => {
    if (context.state.operationsTypesList.length) return

    const res = await operationsApi.getOperationsTypesList({
        onlyListed: true,
        isSigned: true
    })

    if (res) { context.commit('SAVE_OPERATIONS_TYPES', res.data.data) }

    return res
}

/** request to remove signature from operation
@return { promise } - Remove signature request
*/
export const removeSignatureFromOperation = async (context, payload) => {
    const res = await signedApi.removeSignatureFromOperation(payload)

    return res
}

/** request to cancel operation
@return { promise } - Cancel operation request
*/
export const cancelOperation = async (context, payload) => {
    const res = await operationsApi.cancelOperation(payload)

    return res
}
